import React from "react";
import Layout from "../../../components/layout/layout";
import ReviewBar from "../../../components/review/reviewbar";
import ReviewDetail from "../../../components/review/reviewdetail";
import "./reviewDetail.css";
import ReviewDetailSidebar from "../../../components/review/reviewdetailsidebar";
import { useState } from "react";

const ReviewDetailPage = () => {
  const [itemId, setItemId] = useState(null);

  const handleIdSelection = (selectedItemId) => {
    setItemId(selectedItemId);
  };

  return (
    <Layout>
      <div className='review-detail-page'>
        <div className='container'>
          <div className='review-detail-content-container'>
            <div className='sidebar-review'>
              <ReviewDetailSidebar onIdSelect={handleIdSelection} />
            </div>
            <div className='content-review'>
              <ReviewBar />
              <ReviewDetail itemId={itemId} />
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default ReviewDetailPage;
